export default "__VITE_ASSET__9802320f__"